import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import axios from 'axios';
import { format_number } from '../../../ClientUtils';
const root_string = require("../../../config.json")["root_string"];
const assets = ["ETH", "WETH", "WBTC", "UNI"];

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

export default function V1ExpiredAggregateStats() {
  const classes = useStyles();
  const [data, setData] = React.useState({rows: []});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(4);
  
  useEffect( () => {
    (async () => {
      const res = await axios
        .get(root_string + '/api/data_api/V1_expired_options')
        .catch(err => {
          console.log('Error from V1 Expired options');
        });
      let options = res.data["data"];
      let data = [];
      for (let asset of assets) {
        for (let type of ["call", "put"]) {
          let option_type = asset + "_" + type;
          let to_add = {};
          to_add["type"] = asset + " " + capitalize(type) + " Options";
          to_add["total_number"] = n_options(options, option_type);
          to_add["number_ITM"] = n_ITM(options, option_type);
          to_add["percent_expired_ITM"] = percent_ITM(options, option_type);
          to_add["average_ITM_amount"] = avg_ITM_amount(options, option_type);
          data.push(to_add);
        }
      }
      setData(
        {
          rows: data
        }
      );
    })();
  }, []);
  
  const getEtherscan = (token_address) => {
    return 'https://etherscan.io/token/' + token_address;
  };
  

  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.rows.length - page * rowsPerPage);
  
  
  function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1)
  }
  
  function avg_ITM_amount(options, type) {
    let type_options = options.filter((option) => (option['type'] === type));
    let n = type_options.length;
    let total_ITM = 0;
    for (let option of type_options) {
      if (typeof(option['ITM_amount']) === "number") {
        total_ITM += option['ITM_amount'];
      }
    }
    return ((total_ITM / n).toFixed(2));
  }
  
  function add_commas(value) {
    try {
      if (Math.abs(value) >= 1000){
        return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '$' + value;
      }
    } catch (err) {
        return NaN;
    }
  }
  
  function n_ITM(options, type) {
    let ITM_type_options = options.filter((option) => (option['ITM_bool'] && (option['type'] === type)));
    return ITM_type_options.length;
  }
  
  // returns rounded to 3 decimal places
  function percent_ITM(options, type) {
    let type_options = get_options(options, type);
    let n = type_options.length;
    return (n_ITM(options, type) / n).toFixed(3);
  }
  
  function n_options(options, type) {
    return get_options(options, type).length
  }
  
  function get_options(options, type) {
    return options.filter((option) => (option['type'] === type));
  }
  
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Expired Option Aggregate Stats</TableCell>
            <TableCell align='right'>Total Number</TableCell>
            <TableCell align='right'>Number Expired ITM</TableCell>
            <TableCell align='right'>Percent Expired ITM</TableCell>
            <TableCell align='right'>Average ITM Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.rows
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((option, index) => (
              <TableRow key={option.opyn_name}>
                <TableCell component='th' scope='row'>
                  {option.type}
                </TableCell>
                <TableCell align='right'>{option.total_number}</TableCell>
                <TableCell align='right'>{option.number_ITM}</TableCell>
                
                <TableCell align='right'>{option.percent_expired_ITM}</TableCell>
                <TableCell align='right'>{add_commas(option.average_ITM_amount)}</TableCell>
              </TableRow>
            ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 48 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[4, 8]}
        component='div'
        count={data.rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
